import React from "react";
import { DirectoryItem } from "../component/molecule/DirectoryItem";
import { IconButtonComponent, SwitchButtonComponet } from "../component/atom";
import { IS_DIRECTORY_FOLDER, isFolder, renderTableCell } from "../core/Constant";

export const useQuizTableColumns = ({
  allQuiz,
  folderLoading,
  courseId,
  openFolder,
  onViewBtn,
  onEditPress,
  onPressDelete,
  statusUpdate,
}) => {
  const getDocumentById = (id) => allQuiz.find((d) => String(d.id) === String(id));

  return [
    {
      name: "id",
      label: "Id",
      options: { filter: true, sort: false, display: false },
    },
    {
      name: "name",
      label: "NAME",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const docId = tableMeta.rowData[0];
          const doc = getDocumentById(docId) || allQuiz.find((q) => q.name === value);

          if (!doc) return value;

          return (
            <DirectoryItem
              name={doc.name}
              isFolder={isFolder(doc)}
              isLoading={folderLoading}
              onClick={() => openFolder(doc, courseId)}
            />
          );
        },
      },
    },
    {
      name: "is_directory",
      label: "TYPE",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          Number(value) === IS_DIRECTORY_FOLDER ? "Folder" : "Quiz",
      },
    },
    {
      name: "duration",
      label: "Time (Minutes)",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const docId = tableMeta.rowData[0];
          const doc = getDocumentById(docId);
          return doc && isFolder(doc) ? "-" : value;
        },
      },
    },
    {
      name: "no_of_attempts",
      label: "No Of Attempts",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const docId = tableMeta.rowData[0];
          const doc = getDocumentById(docId);
          return doc && isFolder(doc) ? "-" : value;
        },
      },
    },
    {
      name: "full_path",
      label: "Path",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const docId = tableMeta.rowData[0];
          const doc = getDocumentById(docId);
          const path = doc?.full_path || value;

          if (!path) return "-";

          return renderTableCell(path, {
            maxLength: 30,
            rowIndex: tableMeta.rowIndex,
            placement: "top",
          });
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <SwitchButtonComponet
            checked={!!value}
            onChange={() => statusUpdate(tableMeta)}
            inputProps={{ "aria-label": "controlled" }}
          />
        ),
      },
    },
    {
      name: "view",
      label: "View",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const docId = tableMeta.rowData[0];
          const doc = getDocumentById(docId);

          if (!doc) return "-";
          if (isFolder(doc)) {
            return (
              <IconButtonComponent
                btnType={"viewIconbtn"}
                onclick={() => openFolder(doc, courseId)}
              />
            );
          }
          return (
            <IconButtonComponent
              btnType={"viewIconbtn"}
              onclick={() => onViewBtn(tableMeta)}
            />
          );
        },
      },
    },
    {
      name: "id",
      label: "Edit",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <IconButtonComponent
            btnType={"editbtn"}
            onclick={() => onEditPress(tableMeta)}
          />
        ),
      },
    },
    {
      name: "delete",
      label: "Delete",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <IconButtonComponent
            btnType={"deleteIconbtn"}
            onclick={() => onPressDelete(tableMeta)}
          />
        ),
      },
    },
  ];
};